/**
 * Formatters Registry
 *
 * Named formatting functions that can be referenced in the form schema.
 * These format values as the user types (e.g., adding dashes to SSN).
 */

import type { FormatterFn } from '../../config/intakeFormSchema';
import { formatSSN, formatPhone, formatZipCode } from '../../utils/intake';

export type FormatterFunction = (value: string) => string;

// =============================================================================
// Formatter Registry
// =============================================================================

const formatterRegistry: Record<FormatterFn, FormatterFunction> = {
  format_ssn: formatSSN,
  format_phone: formatPhone,
  format_zip: formatZipCode,
};

// =============================================================================
// Public API
// =============================================================================

/**
 * Get a formatter function by name
 */
export const getFormatter = (name: FormatterFn): FormatterFunction => {
  return formatterRegistry[name];
};

/**
 * Apply formatting to a value using the named formatter
 * Returns the formatted value, or original if no formatter
 */
export const applyFormatter = (
  formatterName: FormatterFn | undefined,
  value: string
): string => {
  if (!formatterName) return value;
  const formatter = getFormatter(formatterName);
  if (!formatter) {
    console.warn(`Formatter not found: ${formatterName}`);
    return value;
  }
  return formatter(value);
};
